import React from 'react';
import PropTypes from 'prop-types';
import { StyledGimme20Price } from '../../../../features/browse/PlpTile/views/styles/Promotion.style';
import { convertHtml } from '../../../../features/CnC/LoyaltyBanner/util/utility';

const RecommendationPromoMessage = ({ message }) => {
  return (
    <div className="promo-recommendation-wrapper">
      {message?.isNewPromoMessage && message?.isNewPromo ? (
        <>
          {message?.newPromotionMessage?.price && (
            <StyledGimme20Price className="promo_price">
              {`$${message?.newPromotionMessage?.price} `}
            </StyledGimme20Price>
          )}
          {message?.newPromotionMessage?.code && (
            <span className="promo_message">{` ${message?.newPromotionMessage?.code?.toUpperCase()}`}</span>
          )}
        </>
      ) : (
        convertHtml(message?.promotionMessage)
      )}
    </div>
  );
};

export default RecommendationPromoMessage;

RecommendationPromoMessage.propTypes = {
  message: PropTypes.shape({
    promotionMessage: PropTypes.string,
    newPromotionMessage: PropTypes.shape({ price: PropTypes.string, code: PropTypes.string }),
    isNewPromoMessage: PropTypes.bool,
    isNewPromo: PropTypes.bool,
  }).isRequired,
};
